import { Injectable } from '@angular/core';
import { DeliveryWindowItemDto } from '@libs/shared/models';
import { DateTime } from 'luxon';
import { Observable, throwError } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({
  providedIn: 'root',
})
export class DeliveryInfoRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public getDeliveryWindows(dateFrom: DateTime, dateTo?: DateTime): Observable<DeliveryWindowItemDto[]> {
    const urlParams: URLSearchParams = new URLSearchParams();
    const dateFromIso: string | null = dateFrom.toISODate();

    if (!dateFromIso) {
      return throwError(() => new Error('DateFrom is not a valid Date'));
    }

    urlParams.append('dateFrom', dateFromIso);

    if (dateTo) {
      const dateToIso: string | null = dateTo.toISODate();

      if (!dateToIso) {
        return throwError(() => new Error('DateTo is not a valid Date'));
      }

      urlParams.append('dateTo', dateToIso);
    }

    return this.connector.connect('service', 'deliveryWindows', { searchParams: Object.fromEntries(urlParams) });
  }
}
